import { merge } from 'lodash'

const mixins = [
    require('./app').default,
    require('./format').default,
    require('./wallet').default,
];

export default merge(...mixins)
